import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import { KTIcon } from '../../../../_theme/helpers/components/KTIcon';
import SimpleLoader from './SimpleLoader';

interface DeleteConfirmationModalProps {
  show: boolean;
  onClose: () => void;
  onConfirm: () => void;
  deleteMessage?: string;
  popupLoader?:boolean;
}

const DeleteConfirmationModal: React.FC<DeleteConfirmationModalProps> = ({
  show,
  onClose,
  onConfirm,
  deleteMessage = '',
  popupLoader=false
}) => {
  return (
    <>
    <Modal
        show={show}
        onHide={onClose}
        dialogClassName='modal-dialog modal-dialog-centered'
        backdrop="static" keyboard={false}
      >
        <div className='modal-header pb-5'>
            <h2>Delete Confirmation</h2>
            <div className='btn btn-sm btn-icon btn-active-color-primary' onClick={onClose}>
                <KTIcon className='fs-1' iconName='cross' />
            </div>        
        </div>
        <div className='modal-body text-center'>
            <p className='fs-5'>{deleteMessage}</p>
        </div>
        <Modal.Footer className='justify-content-center'>
            <Button variant='secondary' onClick={onClose} disabled={popupLoader}>
                Cancel
            </Button>
            <Button
                variant='danger'
                onClick={onConfirm}
                disabled={popupLoader}
            >
                {popupLoader ? (
                <>
                  Deleting... <i className="fa-solid fa-spinner fa-spin"></i>
                </>
              ) : (
                "Delete"
              )}
            </Button>
        </Modal.Footer>
    </Modal>
    </>
  );
};

export default DeleteConfirmationModal;
